import { Check, SIconType } from "../../types";
import { Colors, Metrics } from "../../resources";
import React, { useEffect, useState } from "react";
import { StyleSheet, TouchableOpacity } from "react-native";

import SIcon from "./SIcon";

interface IProps {
  checkType?: Check;
  onCheck: (check: Check) => void;
}

const SCheckButton: React.FC<IProps> = ({
  checkType = Check.Unchecked,
  onCheck,
}) => {
  const [check, setCheck] = useState<Check>(checkType);

  useEffect(() => {
    setCheck(checkType);
  }, [checkType]);

  const onPress = () => {
    const nextState = check === Check.Checked ? Check.Unchecked : Check.Checked;

    onCheck(nextState);
    setCheck(nextState);
  };

  const isChecked = check !== Check.Unchecked;

  return (
    <TouchableOpacity
      style={[styles.container, isChecked && styles.checked]}
      onPress={onPress}
    >
      {isChecked ? (
        <SIcon
          type={check === Check.Checked ? SIconType.Check : SIconType.Dash}
          color={Colors.white}
          size={Metrics.iconSuperSmall}
        />
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    height: Metrics.iconSmall,
    width: Metrics.iconSmall,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: Metrics.borderRadiusStandard,
    borderWidth: 1,
    borderColor: Colors.grey300,
    paddingTop: 1,
  },
  checked: {
    borderWidth: 0,
    backgroundColor: Colors.blue400,
  },
});

export default SCheckButton;
